// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"796":"c3c0d589","966":"02f95b20"}[chunkId] + ".chunk.js";
};